<ejs-grid #grid
          class="grid-with-toolbar"
          width="100%"
          rowHeight="38"
          [dataSource]="subscriptions"
          [editSettings]="editSettings"
          [searchSettings]="searchOptions"
          (commandClick)="commandClicked($event)"
          (actionComplete)="actionComplete($event)"
          (actionBegin)="actionBegin($event)">
  <ng-template #toolbarTemplate
               let-data>
    <ejs-toolbar>
      <e-items>
        <e-item text="{{ 'i18n.domain.parker-administration.add-subscription' |  translate }}"
                prefixIcon="e-icons icon-add"
                (click)="onAdd()"></e-item>
        <e-item text="{{ 'i18n.domain.parker-administration.add-subscription-by-set' |  translate }}"
                prefixIcon="e-icons icon-add"
                (click)="onAdd(true)"></e-item>
      </e-items>
    </ejs-toolbar>
  </ng-template>
  <e-columns>
    <e-column field="id"
              [visible]="false"
              headerText="id"
              [isPrimaryKey]="true"></e-column>
    <e-column field="subscription.name"
              headerText="{{'i18n.domain.parker-administration.detail.grid.name' | translate}}"
              clipMode="EllipsisWithTooltip">
      <ng-template #template let-data>
        <span [ngClass]="{'text-danger': !data.subscription?.assignable}">{{data.subscription?.name}}</span>
      </ng-template>
    </e-column>
    <e-column field="subscription.description"
              headerText="{{'i18n.domain.parker-administration.detail.grid.description' | translate}}"
              clipMode="EllipsisWithTooltip"></e-column>
    <e-column field="subscription.active"
              width="70px"
              headerText="{{'i18n.shared.fields.active' | translate}}"
              clipMode="EllipsisWithTooltip">
      <ng-template #template
                   let-data>
        <span class="e-icons"
              [class.icon-checkmark]="data.active"></span>
      </ng-template>
    </e-column>
    <e-column field="validFrom"
              headerText="{{'i18n.domain.parker-administration.detail.grid.from' | translate}}"
              clipMode="EllipsisWithTooltip">
      <ng-template #template
                   let-data>
        <span *ngIf="data.validFrom">{{data.validFrom | date:'dd.MM.yyyy HH:mm'}}</span>
        <span *ngIf="!data.validFrom">{{'i18n.domain.parker-administration.detail.form.immediate' | translate}}</span>
      </ng-template>
    </e-column>
    <e-column field="validTo"
              headerText="{{'i18n.domain.parker-administration.detail.grid.to' | translate}}"
              clipMode="EllipsisWithTooltip">
      <ng-template #template
                   let-data>
        <span *ngIf="data.validTo">{{data.validTo | date:'dd.MM.yyyy HH:mm'}}</span>
        <span *ngIf="!data.validTo">{{'i18n.domain.parker-administration.detail.form.always' | translate}}</span>
      </ng-template>
    </e-column>
    <e-column headerText=""
              [commands]="commands"
              width="120px"></e-column>
  </e-columns>
  <ng-template #editSettingsTemplate
               let-data>
    <app-edit-parker-edit-subscription-list-form *ngIf="formEnabled" [parkerSubscriptionForm]="gridEditForm"
                                                 [clientId]="clientId" [useSubscriptionSets]="useSetsAddMode">
    </app-edit-parker-edit-subscription-list-form>
  </ng-template>

</ejs-grid>
